export default {
  baseStyle: {
    popper: {
      zIndex: "popover",
    },
  },
};
